import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextContentEs = () => {
    return (
        <HighlightedText
            text="RECLAMA TU BONO 325% de bono + 400 giros gratis"
            highlights={[{ word: '325%' }, { word: '400' }]}
            breakBeforeWords={['325%', '+']}
            className={styles.text_content}
        />
    )
}
